import { ArrowDownOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Select, Typography } from 'antd';
import React from 'react';

export interface IListFilterOption {
  value: string;
  label: string;
}

export interface IListFilter {
  type: 'search' | 'select';
  key: string;
  label: string;
  placeholder?: string;
  options?: IListFilterOption[];
  colSpan?: number;
  onChange: (value: any) => void;
}

interface IProps {
  filterValues: Record<string, any>;
  filters: IListFilter[][];
}

const ListFilterRow: React.FC<IProps> = ({ filterValues, filters }) => {
  return (
    <React.Fragment>
      {filters.map((rowFilters, rowIndex) => (
        <Row
          key={rowIndex}
          gutter={{ xs: 8, sm: 15 }}
          style={{ paddingBottom: 12 }}
        >
          {rowFilters.map((filter) => (
            <Col key={filter.key} span={filter.colSpan}>
              <Typography.Text className='text-3 text-gray block font-semibold mb-1'>
                {filter.label}
              </Typography.Text>
              {filter.type === 'search' ? (
                <Input
                  placeholder={filter.placeholder || 'Search by keyword'}
                  suffix={<SearchOutlined />}
                  allowClear
                  value={filterValues['search']}
                  onChange={(e) => filter.onChange(e.target.value)}
                />
              ) : (
                <Select
                  style={{ width: '100%' }}
                  value={filterValues[filter.key]}
                  options={filter.options}
                  showSearch
                  allowClear
                  optionFilterProp='label'
                  placeholder={filter.label}
                  suffixIcon={<ArrowDownOutlined />}
                  onChange={(value) => filter.onChange(value)}
                />
              )}
            </Col>
          ))}
        </Row>
      ))}
    </React.Fragment>
  );
};

export default ListFilterRow;
